import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const MoonIcon: React.FC<IconProps> = props => (
  <BaseIcon viewboxSize="lg" {...props}>
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
  </BaseIcon>
);
